<template>
  <b-form-group
    label="Çalışma Saatleri"
    label-for="time-picker-group"
  >
    <validation-provider
      #default="{ errors }"
      name="Çalışma Saatleri"
      rules="required"
    >
      <b-row>
        <b-col>
          <v-select
            id="start-time"
            v-model="workItem.stime"
            :options="times"
            placeholder="Başlangıç Saati"
            :clearable="false"
          />
        </b-col>
        <b-col>
          <v-select
            id="end-time"
            v-model="workItem.etime"
            :options="times"
            placeholder="Bitiş Saati"
            :clearable="false"
          />
        </b-col>
      </b-row>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'WorkTimes',
  components: {
    BRow,
    BCol,
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      required,
      times: [
        '08:00',
        '08:15',
        '08:30',
        '08:45',
        '09:00',
        '09:15',
        '09:30',
        '09:45',
        '10:00',
        '10:15',
        '10:30',
        '10:45',
        '11:00',
        '11:15',
        '11:30',
        '11:45',
        '12:00',
        '12:15',
        '12:30',
        '12:45',
        '13:00',
        '13:15',
        '13:30',
        '13:45',
        '14:00',
        '14:15',
        '14:30',
        '14:45',
        '15:00',
        '15:15',
        '15:30',
        '15:45',
        '16:00',
        '16:15',
        '16:30',
        '16:45',
        '17:00',
        '17:15',
        '17:30',
        '17:45',
        '18:00',
        '18:15',
        '18:30',
        '18:45',
        '19:00',
        '19:15',
        '19:30',
        '19:45',
        '20:00',
        '20:15',
        '20:30',
        '20:45',
        '21:00',
        '21:15',
        '21:30',
        '21:45',
        '22:00',
        '22:15',
        '22:30',
      ],
    }
  },
  computed: {
    workItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
